module.exports = __webpack_public_path__ + "img/stage.625bd5b1.png";